import { Drawer, Flex } from "antd";
import {
  forwardRef,
  memo,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import "../DialogueCard/index.scss";

//底部抽屉
const FooterDrawer = forwardRef(({ cardRef, linkList }: any, ref) => {
  const [open, setOpen] = useState(false);
  const cardBodyRef = useRef<HTMLDivElement | null>(null);

  useImperativeHandle(ref, () => {
    return {
      setVisit: (visible: boolean) => {
        setOpen(visible);
      },
    };
  });

  useEffect(() => {
    if (cardRef?.current) {
      cardBodyRef.current =
        cardRef?.current?.querySelector(".ant-pro-card-body");
    }
  }, [cardRef]);

  return (
    <Drawer
      title=""
      onClose={() => setOpen(false)}
      open={open}
      placement="bottom"
      getContainer={() => cardBodyRef?.current || document.body}
      rootClassName={`custom-drawer-wrap`}
      closeIcon={false}
      height={140}
    >
      <Flex align="center" wrap gap={16}>
        {linkList?.map((item: any, index: number) => (
          <a
            key={index}
            className="modal-action action-text"
            target="_black"
            href={item?.url || "#"}
            onClick={
              !item?.url
                ? (e) => {
                    e.preventDefault();
                  }
                : undefined
            }
          >
            {item.text}
          </a>
        ))}
      </Flex>
    </Drawer>
  );
});

export default memo(FooterDrawer);
